import { render, staticRenderFns } from "./PhonePaused.vue?vue&type=template&id=4426444f"
import script from "./PhonePaused.vue?vue&type=script&lang=js"
export * from "./PhonePaused.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports